export enum Environment {
	local = "local",
	integration = "integration",
	production = "production",
}

export const ENV_VARS = {
	VITE_PLATFORM_API_URL: import.meta.env.VITE_PLATFORM_API_URL,
	VITE_ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
	VITE_BASE_DIR: import.meta.env.VITE_BASE_DIR,
	VITE_STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
	VITE_PUBLIC_POSTHOG_KEY: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
	VITE_PUBLIC_LD_CLIENT_SIDE_ID: import.meta.env.VITE_PUBLIC_LD_CLIENT_SIDE_ID,
	VITE_NEW_PLATFORM_URL: import.meta.env.VITE_NEW_PLATFORM_URL,
};

export function getCurrentEnv() {
	return ENV_VARS.VITE_ENVIRONMENT ?? Environment.local;
}

export function getSummerHost() {
	switch (getCurrentEnv()) {
		case Environment.local:
			return "https://int.bria.ai";
		case Environment.integration:
			return "https://int.bria.ai";
		default:
			return "https://labs.bria.ai";
	}
}

export function isLocal() {
	return getCurrentEnv() === Environment.local;
}

export function isIntegration() {
	return getCurrentEnv() === Environment.integration;
}

export function isProduction() {
	return getCurrentEnv() === Environment.production;
}

export function isCloudEnv() {
	return isProduction() || isIntegration();
}
